import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root',
})
export class DealService {
  constructor(private _api: ApiService) { }

  getDealById(dealId: string | number): Observable<any> {
    const results = this._api.get(`Deal/${dealId}`).pipe(map((data) => data));
    return results;
  }

  getDealByName(dealName: string): Observable<any> {
    const results = this._api
      .get(`Deal/ByName/${dealName}`)
      .pipe(map((data) => data));
    return results;
  }

  getAllDeals(): Observable<any> {
    return this._api.get(`Deal/HomePageDeals`).pipe(map((data) => data));
  }

  updateDeal(dealId: number, customerId: number): Observable<any> {
    return this._api
      .post(`Deal/UpdateAboutDeal`, { dealId, customerId })
      .pipe(map((data) => data));
  }

  suggestDeal(suggestion: any): Observable<any> {
    return this._api
      .post(`Deal/SuggestDeal`, { ...suggestion })
      .pipe(map((data) => data));
  }

  getProductExpectedDeliveryDate(productId: number): Observable<any> {
    return this._api
      .get(`Deal/GetProductExpectedDeliveryDate?productId=${productId}`)
      .pipe(map((data) => data));
  }

  getDealCategoriesFromApi() {
    return this._api.get<any[]>(`Deal/GetAllDealCategories`);
  }

  validateVoucher(dealId: number, code: string) {
    return this._api.get<any>(`Deal/ValidateVoucher`, { dealId, code }
    ).pipe(map((data) => data));
  }

  getDealCategories() {
    return [
      { value: '', label: 'All Category' },
      { value: 'electronics', label: 'Electronics' },
      { value: 'home-appliances', label: 'Home Appliances' },
      { value: 'mobile-phones', label: 'Mobile Phones' },
      { value: 'computers-tablets', label: 'Computers & Tablets' },
      { value: 'fashion', label: 'Fashion & Apparel' },
      { value: 'health-beauty', label: 'Health & Beauty' },
      { value: 'home-kitchen', label: 'Home & Kitchen' },
      { value: 'toys-games', label: 'Toys & Games' },
      { value: 'sports-outdoors', label: 'Sports & Outdoors' },
      { value: 'automotive', label: 'Automotive' },
      { value: 'books-media', label: 'Books & Media' },
      { value: 'office-supplies', label: 'Office Supplies' },
      { value: 'jewelry-accessories', label: 'Jewelry & Accessories' },
      { value: 'groceries-food', label: 'Groceries & Food' },
      { value: 'pet-supplies', label: 'Pet Supplies' },
      { value: 'tools-home-improvement', label: 'Tools & Home Improvement' },
      { value: 'garden-outdoor', label: 'Garden & Outdoor' },
      { value: 'baby-products', label: 'Baby Products' },
      { value: 'arts-crafts', label: 'Arts & Crafts' },
      { value: 'travel-luggage', label: 'Travel & Luggage' },
      { value: 'other', label: 'Other' }
    ];
  }

  getOrders(
    startDate: string,
    endDate: string,
    startRow: number,
    endRow: number,
    filterModel: any,
    sortModel: any,
    companyId: string
  ): Observable<any> {
    const data = {
      startDate,
      endDate,
      startRow,
      endRow,
      filterModel,
      sortModel,
      companyId,
    };

    return this._api.post<any>(`Order/GetOrdersForCleverDeals`, data);
  }

  
  splitOrder(orderId: number): Observable<any> {
    return this._api
      .post<any>(`Order/SplitOrder`, orderId) // send orderId in the body
      .pipe(map((data) => data));
  }


}
